import { useCallback } from 'react';
import useWfApi from './axios/useWfApi';
import { WfTyphoon } from '../models/WfTyphoon';

export interface WfDisasterRegisterBody {
  typhoonName: string;
  targetBranchIds: string[];
  startDateTime: string;
  stopDateTime: string;
  disasterId?: string;
}

export interface WfDisasterSystemLaunchBody {
  disasterId: string;
  userId: string;
  launchDateTime?: string;
  shutdownDateTime?: string;
}

function useWfDisasterRepo() {
  const { post, get } = useWfApi();

  const postDisasterRegisterRequest = useCallback(
    async (body: WfDisasterRegisterBody) => {
      try {
        return (await post<WfTyphoon>('/api/wf/disasters', body)) ?? null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [post]
  );

  const getDisasterLatestRequest = useCallback(async () => {
    try {
      return (await get<WfTyphoon>('/api/wf/disasters/latest')) ?? null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [get]);

  const postDisasterSystemLaunchRequest = useCallback(
    async (body: WfDisasterSystemLaunchBody) => {
      try {
        return (await post<WfTyphoon>('/api/wf/system-launch', body)) ?? null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [post]
  );

  return {
    postDisasterRegisterRequest,
    getDisasterLatestRequest,
    postDisasterSystemLaunchRequest,
  };
}

export default useWfDisasterRepo;
